import { View } from 'components/View'
import getPathnameRouterSelect from 'modules/router/selectors/get-pathname'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import setMetaAttributesRouteUtil from 'modules/routes/utils/set-meta-attributes'
import { logUtil } from 'packages/src'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { setCanonicalUrlDomUtil } from 'modules/dom/utils/set-canonical-url/index.js'
import getLocationRouterSelect from 'modules/router/selectors/get-location/index.js'
import { getCanonicalUrlRouteUtil } from 'modules/routes/utils/get-canonical-url/index.js'

/**
 * @param props
 * @param props.value
 * @param props.title
 * @param props.shouldNotHavePadding
 * @param props.children
 * @param props.description
 * @param props.url
 * @return {Element}
 * @constructor
 */
export default function Page (props) {
  const {
    value,
    title,
    shouldNotHavePadding,
    children,
    description,
    url
  } = props
  const pathname = useSelector(getPathnameRouterSelect)
  const location = useSelector(getLocationRouterSelect)
  logUtil('Page').debug('props=', props)
  const intl = useIntl()
  const canonicalUrl = getCanonicalUrlRouteUtil({
    url,
    location
  })

  React.useEffect(() => {
    setMetaAttributesRouteUtil({
      instance: value,
      title,
      pathname,
      description,
      intl
    })
  }, [
    title,
    value,
    pathname,
    description
  ])

  React.useEffect(() => {
    setCanonicalUrlDomUtil(canonicalUrl)
  }, [
    canonicalUrl
  ])

  return (
    <View
      h
      p={shouldNotHavePadding ? 0 : 1}
      pos='relative'
    >
      {children}
    </View>
  )
}
